/**
 * @jsxRuntime classic
 * @jsx jsx
 */


import React, { createContext } from 'react';

import type { TokenListColumns } from '../types';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export const TableColumnsContext: React.Context<TokenListColumns> = createContext<TokenListColumns>(
	[],
);
